import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';

import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';

const NetworkLostNotifier = () => {
    const networkEstablished = useAppSelector((state) =>
        state.app.getIn(['networkConnection', 'established']),
    );
    const { i18next } = useAppContext();

    const [showNotifier, setShowNotifier] = useState(false);

    useEffect(() => {
        setShowNotifier(networkEstablished === false);
    }, [networkEstablished]);

    if (!showNotifier) {
        return null;
    }

    return (
        <NotifierBanner
            message={i18next.t('network.lost.message')}
            buttonText={i18next.t('dismiss')}
            handleClick={() => setShowNotifier(false)}
        />
    );
};

export default NetworkLostNotifier;
